import Features from "@/utils/json/featuresLoader";


/**
 * -- READ ME --
 * 1. All routes with `scrollable: false` will have hidden scrollbar.
 * 2. If you want to hide the scrollbar for a specific route, you can add it to the HIDDEN_SCROLLBAR_EXACT_PATHS array.
 * 3. If you want to hide the scrollbar for a child routes of a specific route, you can add it to the HIDDEN_SCROLLBAR_DETAIL_PREFIXES array.
 */

/** Full pathname match (e.g. `/my-tasks`). */
const HIDDEN_SCROLLBAR_EXACT_PATHS = [] as const;

/** Detail routes: `/prefix/[id]` and nested paths (e.g. `/active-projects/12195`). */
const HIDDEN_SCROLLBAR_DETAIL_PREFIXES = [] as const;

function escapeRegex(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

const HIDDEN_SCROLLBAR_DETAIL_PATTERNS = HIDDEN_SCROLLBAR_DETAIL_PREFIXES.map(
  prefix => new RegExp(`^${escapeRegex(prefix)}/[^/]+(?:/[^/]+)*$`)
);

export function isHiddenScrollbarRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false;

  const features = Features.mainSidebarItems.find(feature => {
    if(  feature.path === pathname ||
      feature.pathPrefix === pathname  )
      return true;
      const submenu = feature.submenu?.find(submenu =>  (feature.path || feature.pathPrefix+submenu.submenuPath) === pathname);
      if(submenu && submenu.scrollable === false) return true;
  });

  if (features && features?.scrollable === false) {
    return true;
  }

  if ((HIDDEN_SCROLLBAR_EXACT_PATHS as readonly string[]).includes(pathname)) {
    return true;
  }

  return HIDDEN_SCROLLBAR_DETAIL_PATTERNS.some(pattern => pattern.test(pathname));
}
